import { axios } from '~/plugins/axios'

const BASE_URL = '/api/reports/client-activity'

const actions = {
  async fetchFeed(_, payload) {
    const resp = await axios.post(`${BASE_URL}/feed`, payload)
    return resp.data
  },

  async fetchSummary(_, payload) {
    const resp = await axios.post(`${BASE_URL}/summary`, payload)
    return resp.data.data
  },

  async fetchClients(_, payload) {
    const resp = await axios.post(`${BASE_URL}/clients`, payload)
    return resp.data.data || []
  },

  async fetchSections(_, payload) {
    const resp = await axios.post(`${BASE_URL}/sections`, payload)
    return resp.data.data || []
  },
}

export default {
  namespaced: true,
  actions,
}
